import { render, staticRenderFns } from "./VehicleDetailLicences.vue?vue&type=template&id=14da06fa"
import script from "./VehicleDetailLicences.vue?vue&type=script&lang=js"
export * from "./VehicleDetailLicences.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports